module.exports = __webpack_public_path__ + "static/media/down-arrow.9e77aa74.svg";